import React from 'react';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className='landing-background'>
      <div className='container'>
        <center>
          <h1 className='display-4 mt-5 text-white'>
            SPATIAL
          </h1>
          <h2 className='h4 text-white mb-0'>Monetizing Dynamic NFTs of Real World</h2>
          <h2 className='h4 text-white'>Spatial Maps using Chainlink Oracles</h2>
          <button className='btn btn-primary btn-lg mt-3 primary-color' onClick={() => navigate('/map')}>
            Get Started
          </button>
        </center>
      </div>
    </div>
  )
}

export default Landing;